module.exports = __webpack_public_path__ + "static/2-65d08375a6de05672860915af8bb3670.png";